import React from 'react'
import { Spinner } from 'react-bootstrap'

export function GlobalSpinner() {
  return (
    <div className="vh-100 vw-100 w-100 d-flex justify-content-center align-items-center gap-3">
      <Spinner />
    </div>
  )
}
